<div>
    <div class="input-group">
        @if (!isShowProtectedList() && (isEmailType() || isPasswordType())) {
            <span class="input-group-addon">
                <img
                    class="element-icon"
                    src="./assets/img/websites/forms-icons/lpc-f-{{ type() }}-icon.svg"
                    alt="{{ type() }} icon"
                />
            </span>
        }
        @if (isShowProtectedList() || isShowDropdown()) {
            <div
                class="input-group-btn elements-dropdown"
                [class.disabled]="isFormControlDisabled()"
                dropdown
                container="body"
            >
                <button class="btn btn-default type-dropdown-toggle" type="button" dropdownToggle>
                    <img
                        class="element-icon"
                        src="./assets/img/websites/forms-icons/lpc-f-{{ type() }}-icon.svg"
                        alt="{{ type() }} icon"
                    />
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu custom-left-position" *dropdownMenu>
                    @if (isShowDefaultList()) {
                        @for (controlType of defaultElements().keys(); track controlType) {
                            @if (
                                controlType === formInputType.email
                                    ? !isHasEmail()
                                    : controlType === formInputType.phone
                                      ? !isHasPhone()
                                      : controlType === formInputType.file
                                        ? !isHasFile()
                                        : true
                            ) {
                                <li (click)="changeElementType(controlType)">
                                    <a>
                                        <img
                                            class="element-icon"
                                            src="./assets/img/websites/forms-icons/lpc-f-{{ controlType }}-icon.svg"
                                            alt="{{ controlType }} icon"
                                        />
                                        {{ controlsLabels[controlType] | translate }}
                                    </a>
                                </li>
                            }
                        }
                    } @else {
                        @for (controlType of defaultProtectedElements().keys(); track controlType) {
                            <li
                                [class.disabled]="
                                    controlType === formInputType.email
                                        ? !isHasEmail()
                                        : controlType === formInputType.phone
                                          ? !isHasPhone()
                                          : controlType === formInputType.file
                                            ? !isHasFile()
                                            : false
                                "
                                (click)="changeElementType(controlType)"
                            >
                                <a>
                                    <img
                                        class="element-icon"
                                        src="./assets/img/websites/forms-icons/lpc-f-{{ controlType }}-icon.svg"
                                        alt="{{ controlType }} icon"
                                    />
                                    {{ controlsLabels[controlType] | translate }}
                                </a>
                            </li>
                        }
                    }
                </ul>
            </div>
        }

        @if (!isCheckboxType()) {
            <input
                type="text"
                class="form-control"
                [class.disabled]="isHiddenType()"
                [value]="label()"
                (input)="onLabelChange($event)"
            />
        }
        @if (isCheckboxType()) {
            <input type="text" class="form-control disabled" [value]="'control_checkbox' | translate" />
        }
    </div>
    @if (isCheckboxType()) {
        <div class="mb-20">
            <sp-common-editor
                class="sp-editor form-control checkbox-textarea"
                [toolbarMenu]="'bold italic link'"
                [content]="label()"
                [baseHref]="baseHref()"
                [deviceMode]="deviceMode()"
                (changeContent)="saveLabel($event)"
            >
            </sp-common-editor>
        </div>
    }

    @if ((isInputLike() || isTextareaType()) && !isHiddenType() && !isPasswordType()) {
        <div class="form-group mb-20">
            @if (!isDateType()) {
                <input
                    class="form-control"
                    type="text"
                    [class.disabled]="isDynamicPlaceholderEnabled()"
                    [placeholder]="'control_input_placeholder' | translate"
                    [value]="placeholder()"
                    (input)="onPlaceholderChange($event)"
                />
            }

            @if (isSystemElement() && !isPasswordType() && !isFileType()) {
                <span class="help-block small">
                    {{ "system_variable_help" | translate }}
                    <a class="dotted" [tooltip]="varNameTooltip" placement="bottom" triggers="mouseover:mouseleave">
                        {{ variable() }}
                    </a>
                    <ng-template #varNameTooltip>
                        {{ "system_variable" | translate }} <span class="system-variable-label">{{ variable() }}</span>
                    </ng-template>
                </span>
            }

            @if (isFileType()) {
                <span class="help-block small">
                    {{ "control_file_crm_deal" | translate }}
                </span>
            }
        </div>
    }

    @if (isPhoneType()) {
        <div class="form-horizontal form-row mb-20">
            <div class="form-group">
                <label class="control-label col-xs-9">
                    {{ "form_use_dynamic_mask" | translate }}
                    <span
                        class="small sp-icon icon-question color-light hover-effect"
                        [tooltip]="'form_use_dynamic_mask_tooltip' | translate"
                        [placement]="'top'"
                        [adaptivePosition]="true"
                        triggers="mouseover:mouseleave"
                    ></span>
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch
                        [active]="isDynamicPlaceholderEnabled()"
                        (toggleActiveEvent)="setDynamicPhonePlaceholder($event)"
                    ></sp-switch>
                </div>
            </div>
        </div>
    }

    @if (isHiddenType()) {
        <div class="form-group mb-20">
            <span class="help-block small">
                {{ "hidden_input_help" | translate }}
            </span>

            <div [class.has-error]="!hiddenValue()">
                <label class="control-label">
                    {{ "hidden_input_value" | translate }}
                </label>
                <input
                    class="form-control"
                    type="text"
                    [placeholder]="'input_value' | translate"
                    [value]="hiddenValue()"
                    (input)="onHiddenValueChange($event)"
                    [attr.maxlength]="255"
                />
                @if (!hiddenValue()) {
                    <span class="help-block small">
                        {{ "control_errors_required" | translate }}
                    </span>
                }
            </div>
        </div>
    }

    @if (isTextareaType() && !isPaymentEduForm()) {
        <div class="form-group mb-20">
            <label class="control-label">
                {{ "crm_data_label" | translate }}
            </label>

            <select class="form-control" (change)="onCrmCommentPlaceChange($event)">
                @for (option of crmCommentPlaceArray; track option) {
                    <option [value]="option" [selected]="crmCommentPlace() === option">
                        {{ option + "_option" | translate }}
                    </option>
                }
            </select>
        </div>
    }

    @if (!isSystemElement() && !isAddressBookListDisabled()) {
        <div class="form-group mb-20">
            <label class="control-label">
                {{ "crm_mailing_list_variable" | translate }}
            </label>

            <select
                class="form-control"
                [class.disabled]="!addressBookVariablesList()?.length"
                (change)="onAddressBookVariableChange($event)"
            >
                <option value="" disabled [selected]="!variable()">
                    {{
                        (addressBookVariablesList()?.length ? "control_choose_variable" : "error_select_address_book")
                            | translate
                    }}
                </option>
                @if (variable()) {
                    <option [value]="variable()" [selected]="true">
                        {{ variable() }}
                    </option>
                }
                @for (ab_var of filteredAddressBookVariables(); track ab_var.variable_name) {
                    <option [value]="ab_var.variable_name" [disabled]="disableAddressBookVariable(ab_var)">
                        {{ ab_var.variable_name }}
                    </option>
                }
            </select>

            @if (isTextareaType()) {
                <div class="help-block small text-muted">
                    {{ "textarea_in_mailing_list_variable_hint" | translate }}
                </div>
            }
        </div>
    }

    @if (isTextareaType() && isPaymentEduForm()) {
        <div class="form-group">
            <div class="alert alert-sm alert-info-mutted">
                {{ "crm_contact_notes_message" | translate }}
            </div>
        </div>
    }

    @if (!isSystemElement() && crmContactsVariablesList()?.length) {
        <div
            class="form-group mb-20"
            [class.has-error]="hasCrmVariableError()"
            [class.disabled]="isCrmContactListDisabled()"
        >
            <label class="control-label">
                {{ "crm_contact_variable" | translate }}
            </label>

            <select
                class="form-control"
                [class.disabled]="!crmContactsVariablesList()?.length || isCrmDealVariableSelect()"
                (change)="onCrmContactVariableChange($event)"
            >
                <option value="" disabled [selected]="crmContactVariable() === null">
                    {{ "control_choose_variable" | translate }}
                </option>
                @if (crmContactVariable() !== null) {
                    <option [value]="crmContactVariable()" [selected]="true">
                        {{ getVariableName(crmContactVariable(), variableTypes.crmContactAttribute) | translate }}
                    </option>
                }
                @for (field of filteredContactFields(); track field) {
                    <option [value]="field" [disabled]="disableFilteredContactFields()">
                        {{ field | translate }}
                    </option>
                }
                @for (variable of filteredCrmContactsVariables(); track variable.id) {
                    <option [value]="variable.id" [disabled]="disableCrmSelectVariable(variable)">
                        {{ variable.name | translate }}
                    </option>
                }
            </select>
            @if (hasCrmVariableError()) {
                <span class="help-block small">
                    {{ "error_crm_contact_or_deal_required" | translate }}
                </span>
            }
        </div>
    }

    @if (!isSystemElement() && crmDealsVariablesList()?.length && !isCrmDealsListDisabled()) {
        <div class="form-group mb-20" [class.has-error]="hasCrmVariableError()">
            <label class="control-label">
                {{ "crm_deal_variable" | translate }}
            </label>

            <select
                class="form-control"
                [class.disabled]="!crmDealsVariablesList()?.length || isCrmContactVariableSelect()"
                (change)="onCrmDealVariableChange($event)"
            >
                <option value="" [selected]="crmDealVariable() === null">
                    {{
                        (crmDealsVariablesList()?.length ? "crm_choose_deal_variable" : "crm_choose_pipeline")
                            | translate
                    }}
                </option>
                @if (crmDealVariable() !== null) {
                    <option [value]="crmDealVariable()" [selected]="true">
                        {{ getVariableName(crmDealVariable(), variableTypes.crmDealAttribute) | translate }}
                    </option>
                }
                @for (variable of filteredCrmDealsVariables(); track variable.id) {
                    <option [value]="variable.id" [disabled]="disableCrmSelectVariable(variable)">
                        {{ variable.name | translate }}
                    </option>
                }
            </select>
            @if (hasCrmVariableError()) {
                <span class="help-block small">
                    {{ "error_crm_contact_or_deal_required" | translate }}
                </span>
            }
        </div>
    }

    @if (addChatBotToForm() && isInitVariables()) {
        @for (chatBot of selectedChatBots(); let i = $index; track i) {
            @let botVariables = filteredBotVariables($any(chatBot.socialNetwork), variablesOptions()[i]);
            @let selected = selectedBotVariable($any(chatBot.socialNetwork));

            <div class="mb-20">
                <div class="form-group">
                    <label class="control-label">
                        {{ "field_in_chat_bot" | translate }} <span>{{ chatBot.botName }}</span>
                    </label>
                    <select class="form-control" (change)="onBotVariableChange(chatBot, $event, botVariables)">
                        <option disabled [selected]="!selected">{{ "choose_bot_variable" | translate }}</option>
                        @for (variable of botVariables; let j = $index; track j) {
                            <option [value]="j" [selected]="selected?._id === variable?._id">
                                {{ variable?.name }}
                            </option>
                        }
                    </select>
                </div>
            </div>
        }
    }

    @if (isRadioType()) {
        <div class="form-group mb-20 options-list">
            @if (isCrmDealVariableSelect() || isCrmContactVariableSelect()) {
                @for (option of options(); let optionsIndex = $index; track optionsIndex) {
                    <div class="well well-sm mb-10">
                        <div class="form-group radio-element">
                            <div>
                                <div class="input-group">
                                    <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                    <input type="text" class="form-control disabled" [value]="option.label" />
                                </div>
                            </div>
                            <div class="radio-btn-container">
                                <input
                                    class="non-editable-check-radio-control"
                                    type="radio"
                                    placement="bottom"
                                    triggers="mouseover:mouseleave"
                                    [checked]="option.selected"
                                    [tooltip]="defaultOptionTooltip"
                                    (click)="checkRadioOption(optionsIndex)"
                                />
                            </div>

                            <ng-template #defaultOptionTooltip>
                                @if (!option.selected) {
                                    <span>{{ "default_options_tooltip_1" | translate }}</span>
                                }
                                @if (option.selected) {
                                    <span>{{ "default_options_tooltip_2" | translate }}</span>
                                }
                            </ng-template>
                        </div>
                    </div>
                }
            } @else {
                @for (option of options(); let optionsIndex = $index; track optionsIndex) {
                    <div class="well well-sm mb-10">
                        <div class="form-group radio-element">
                            <div>
                                <div class="input-group">
                                    <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                    <input
                                        type="text"
                                        class="form-control"
                                        [value]="option.label"
                                        (input)="updateOptionLabel(optionsIndex, $event)"
                                    />
                                </div>
                                <div class="input-group">
                                    <span class="input-group-addon">{{ "form_radio_value" | translate }}</span>
                                    <input
                                        type="text"
                                        class="form-control"
                                        [value]="option.value"
                                        (input)="updateOptionValue(optionsIndex, $event)"
                                    />
                                </div>
                            </div>
                            <button
                                class="btn btn-link"
                                [class.disabled]="options().length === 2"
                                (click)="removeOption(optionsIndex, $event)"
                            >
                                <img src="./assets/img/websites/lpc-delete-icon.svg" alt="delete icon" />
                            </button>

                            <input
                                class="default-check-radio-control"
                                type="radio"
                                placement="bottom"
                                triggers="mouseover:mouseleave"
                                [checked]="option.selected"
                                [tooltip]="defaultOptionTooltip"
                                (click)="checkRadioOption(optionsIndex)"
                            />

                            <ng-template #defaultOptionTooltip>
                                @if (!option.selected) {
                                    <span>{{ "default_options_tooltip_1" | translate }}</span>
                                }
                                @if (option.selected) {
                                    <span>{{ "default_options_tooltip_2" | translate }}</span>
                                }
                            </ng-template>
                        </div>
                    </div>
                }

                <a class="dotted" (click)="addOption()">{{ "add" | translate }}</a>
            }
        </div>
    }

    @if (isSelectType()) {
        <div class="form-group mb-20 options-list">
            @if (isCrmDealVariableSelect() || isCrmContactVariableSelect()) {
                @for (option of options(); let optionsIndex = $index; track optionsIndex) {
                    <div class="well well-sm mb-10">
                        <div class="form-group radio-element">
                            <div>
                                <div class="input-group">
                                    <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                    <input type="text" class="form-control disabled" [value]="option.label" />
                                </div>
                            </div>
                            @if (!option.selected) {
                                <div class="radio-btn-container">
                                    <input
                                        class="non-editable-check-radio-control"
                                        type="radio"
                                        placement="bottom"
                                        triggers="mouseover:mouseleave"
                                        [checked]="option.selected"
                                        [tooltip]="defaultOptionTooltip"
                                        (click)="checkSelectOption(optionsIndex)"
                                    />
                                    <ng-template #defaultOptionTooltip>
                                        @if (!option.selected) {
                                            <span>{{ "default_options_tooltip_1" | translate }}</span>
                                        }
                                        @if (option.selected) {
                                            <span>{{ "default_options_tooltip_2" | translate }}</span>
                                        }
                                    </ng-template>
                                </div>
                            }

                            @if (option.selected) {
                                <div class="radio-btn-container">
                                    <input
                                        class="non-editable-check-radio-control"
                                        type="radio"
                                        [checked]="option.selected"
                                        (click)="checkSelectOption(optionsIndex)"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                }
            } @else {
                @for (option of options(); let optionsIndex = $index; track optionsIndex) {
                    <div class="well well-sm mb-10">
                        <div class="form-group radio-element">
                            <div>
                                <div class="input-group">
                                    <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                    <input
                                        type="text"
                                        [attr.maxlength]="255"
                                        class="form-control"
                                        [value]="option.label"
                                        (input)="updateOptionLabel(optionsIndex, $event)"
                                    />
                                </div>
                                <div class="input-group">
                                    <span class="input-group-addon">{{ "form_radio_value" | translate }}</span>
                                    <input
                                        type="text"
                                        class="form-control"
                                        [value]="option.value"
                                        (input)="updateOptionValue(optionsIndex, $event)"
                                    />
                                </div>
                            </div>
                            <button
                                class="btn btn-link"
                                [class.disabled]="options().length === 2"
                                (click)="removeOption(optionsIndex, $event)"
                            >
                                <img src="./assets/img/websites/lpc-delete-icon.svg" alt="delete icon" />
                            </button>

                            @if (!option.selected) {
                                <div>
                                    <input
                                        class="default-check-radio-control"
                                        type="radio"
                                        placement="bottom"
                                        triggers="mouseover:mouseleave"
                                        [checked]="option.selected"
                                        [tooltip]="defaultOptionTooltip"
                                        (click)="checkSelectOption(optionsIndex)"
                                    />
                                    <ng-template #defaultOptionTooltip>
                                        @if (!option.selected) {
                                            <span>{{ "default_options_tooltip_1" | translate }}</span>
                                        }
                                        @if (option.selected) {
                                            <span>{{ "default_options_tooltip_2" | translate }}</span>
                                        }
                                    </ng-template>
                                </div>
                            }

                            @if (option.selected) {
                                <div>
                                    <input
                                        class="default-check-radio-control"
                                        type="radio"
                                        [checked]="option.selected"
                                        (click)="checkSelectOption(optionsIndex)"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                }

                <a class="dotted" (click)="addOption()">
                    {{ "add" | translate }}
                </a>
            }
        </div>
    }

    <div class="form-horizontal form-row">
        @if (showMakeRequiredPredicate()) {
            <div class="form-group">
                <label class="col-xs-9 control-label">
                    {{ "control_required" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="required()" (toggleActiveEvent)="toggleRequired($event)"></sp-switch>
                </div>
            </div>
        }
    </div>
</div>
